export interface LessonTicketRowProps {
  label: string;
  value: string;
  /** Total row: 20/600 for label and value. */
  emphasis?: boolean;
  /** Discount rows read as a reduction: value in green. */
  tone?: 'default' | 'discount';
  'data-testid'?: string; // lands on the <dd>, like today's receipt rows
}

export function LessonTicketRow({ label, value, emphasis = false, tone = 'default', 'data-testid': testId }: LessonTicketRowProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <dt className={emphasis ? 'text-xl font-semibold leading-tight text-butter-gray-900' : 'text-lg font-medium leading-tight text-butter-gray-700'}>
        {label}
      </dt>
      <dd className={`${emphasis ? 'text-xl' : 'text-lg'} font-semibold leading-tight ${tone === 'discount' ? 'text-green-600' : 'text-butter-gray-900'}`} data-testid={testId}>
        {value}
      </dd>
    </div>
  );
}
